import styles from "../../Sidebar/Sidebar.module.css";
import React from "react";
import { FaClipboardList } from "react-icons/fa6";
import { useTranslation } from "react-i18next";
import { NavLink } from "react-router-dom";

export const OrdersButton: React.FC = () => {
  const { t } = useTranslation();

  return (
    <>
      <NavLink
        to="/transactions"
        className={({ isActive }: { isActive: boolean }) =>
          isActive ? `${styles.navLink} ${styles.active}` : styles.navLink
        }
      >
        <div className={styles.iconWrapper}>
          <FaClipboardList />
        </div>
        <div className={styles.label}>{t("order.label")}</div>
      </NavLink>
    </>
  );
};
